import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", as = "div" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

export const Overline = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs md:text-sm font-bold tracking-[0.2em] uppercase ${
      dark ? "text-white/60" : "text-[#06142E]/50"
    }`}
  >
    <span className="h-px w-8 bg-[#1E63E9]" />
    {children}
  </span>
);
